import Button from '@shared/components/Button/Button';
import { useTranslation } from 'react-i18next';

import useWorkspacesContext from 'modules/Workspaces/WorkspacesProvider/useWorkspacesContext';
import { LoadingMembersStatusEnum } from 'modules/Workspaces/WorkspacesProvider/utils';

const MembersListErrorBlock = () => {
  const { t } = useTranslation();
  const { setLoadingMembersStatus } = useWorkspacesContext();

  return (
    <div className="flex flex-col items-center justify-center py-4">
      <p className="text-black font-medium mb-1">{t('workspaces.couldnt_load_members')}</p>
      <p className="text-gray-80 text-size-sm mb-4">{t('workspaces.we_weren_t_able_to_load_the_member_list')}</p>
      <Button variant="primary" size="sm" onClick={() => setLoadingMembersStatus(LoadingMembersStatusEnum.READY)}>
        {t('try_again')}
      </Button>
    </div>
  );
};

export default MembersListErrorBlock;
